import { getConsentCategoryIds } from "./getConsentCategoryIds";
import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import { setCookieValue, removeCookie } from "../context/cookies";
import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { ONETRUST_CONSENT_CHANGED } from "./constants";

export const emitConsentChangedEvent = () => {
  const consent = getConsentCategoryIds();

  window[asosGlobalNamespace][siteChromeGlobalNamespace].pushToDataLayer({
    OneTrustGroupsUpdated: {
      OnetrustActiveGroups: consent
    }
  });

  window[asosGlobalNamespace].eventBus.emit(ONETRUST_CONSENT_CHANGED, consent);

  window.OneTrust.OnConsentChanged(async event => {
    if (event.detail.includes("C0003")) {
      const { customer } = await sdkInstanceProvider("identity");
      const customerGuid = await customer.customerGuid();
      const isAuthenticated = await customer.isAuthenticated();

      if (isAuthenticated) {
        setCookieValue("asos-cgd26", customerGuid, {
          secure: true,
          sameSite: "Lax"
        });
      }
    } else {
      removeCookie("asos-cgd26");
    }
  });
};
